import { FC, useContext, useEffect, useState } from "react"
import { Form as FormAntd } from 'antd';
import { Card } from "@hdi-seguros/web-components.card";
import { ActionButton } from "@hdi-seguros/web-components.action-button";

import { PersonalInfoForm } from "./components/PersonalInfo";
import { AddressInfoForm } from "./components/AddressInfo";
import { CommunicationChannelsForm } from "./components/CommunicationChannelsInfo";
import { ElectronicPolicyInfoForm } from "./components/ElectronicPolicyInfo";
import { GetProducerInformationResponse } from "../../../../../shared/interfaces/services/get-producer-information-service";
import { AnchorLinkItemProps } from "antd/es/anchor/Anchor";

import { ColSize, RowSize, Form, Anchor, Loading } from "../../../../../shared/components"
import ProducersService from "../../../../../shared/services/producers";
import { AuthContext, UIContext } from "../../../../../shared/contexts";
import { displayErrorMessage, displaySuccessMessage } from "../../../../../shared/utils";
import { COMMUNICATION_TYPE } from "../../shared/communication-type-enum";
import { DECISION_TYPE } from "../../../../../shared/interfaces";

import './index.css'

export const ProducerInfoTab: FC = () => {
    const { isLoading, setIsLoading, setShowError } = useContext(UIContext);
    const authContext = useContext(AuthContext);
    
    const [producerInformation, setProducerInformation] = useState<GetProducerInformationResponse>();
    const [form] = FormAntd.useForm();

    const [isModified, setIsModified] = useState(false);
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const SECTIONS_SIDENAV: Array<AnchorLinkItemProps> = [
        {
            key: 'datos-personales',
            href: '#datos-personales',
            title: 'Datos Personales',
        },
        {
            key: 'domicilio',
            href: '#domicilio',
            title: 'Domicilio',
        },
        {
            href: '#poliza-electronica',
            key: 'poliza-electronica',
            title: 'Póliza Electrónica',
        },
        {
            key: 'canales-comunicacion',
            href: '#canales-comunicacion',
            title: 'Canales de comunicación',
        },
    ];
    
    const getProducerInformation = async () => {
        setIsLoading(true);
        try {

            const response = await ProducersService.getProducerInformation();

            if (response.intermediario) {
                setProducerInformation(response);
            }

        } catch {
            setShowError(true);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if(!producerInformation){
            getProducerInformation()
        }
    }, [])

    const valuesChanges = () =>{
        setIsModified(true)
    }

    const saveChanges = async () => {
        setIsLoadingButton(true);
        let username = authContext?.getUserInfo()?.uid;
        try {
            const updates = [];
            
            const showEmailProducer = form.getFieldValue('showEmailProducer');
            const showNumberProducer = form.getFieldValue('showNumberProducer');
            const optionElectronicPolicy = form.getFieldValue('optionElectronicPolicy');
            const electronicPolicyMail = form.getFieldValue('electronicPolicyMail');

            const producerData = producerInformation?.intermediario;

            if (showEmailProducer !== producerData?.muestraMails) {
                updates.push(ProducersService.postChangeProducerContactInformation(COMMUNICATION_TYPE.MAIL, showEmailProducer, username!));
            }

            if (showNumberProducer !== producerData?.muestraTelefonos) {
                updates.push(ProducersService.postChangeProducerContactInformation(COMMUNICATION_TYPE.TELEFONO, showNumberProducer, username!));
            }
           
            if (optionElectronicPolicy !== producerData?.polizaElectronica?.recibe || electronicPolicyMail !== producerData?.polizaElectronica?.mail) {
                const mail = optionElectronicPolicy === DECISION_TYPE.YES ? electronicPolicyMail : '';

                if(optionElectronicPolicy === DECISION_TYPE.YES){
                    if(mail === '' && optionElectronicPolicy === DECISION_TYPE.YES){
                        displayErrorMessage('El email es obligatorio si selecciona Sí en Póliza Electrónica');
                        return;
                    }
                }
                
                updates.push(ProducersService.postChangeProducerElectronicPolicy(optionElectronicPolicy, mail));
            }

            if (updates.length > 0) {
                await Promise.all(updates);
            }
            setIsModified(false)
            displaySuccessMessage('Datos cambiados correctamente');
        } catch (error) {
        } finally {
            setIsLoadingButton(false);
        }
    };

    return (
        <div className="producer-info-tab">
            {
                isLoading
                    ?   
                        <div>
                            <Card className="producer-info-tab__loading-card" title={"Cargando informacion del usuario, aguarde un momento"} />
                            <Loading />
                        </div>
                    : (
                        <RowSize>
                            <ColSize size={80}>
                                <Form
                                    formProps={{
                                        name: 'producer-data-form',
                                        onFinish: undefined,
                                        form: form,
                                        onValuesChange: valuesChanges
                                    }}
                                >
                                    <PersonalInfoForm intermediaryInformation={producerInformation!.intermediario} />
                                    <AddressInfoForm intermediaryInformation={producerInformation!.intermediario} />
                                    <ElectronicPolicyInfoForm intermediaryInformation={producerInformation!.intermediario} />
                                    <CommunicationChannelsForm intermediaryInformation={producerInformation!.intermediario}  />
                                    <div className="producer-info-tab_save-button-container">
                                        <ActionButton className="producer-info-tab_save-button" loading={isLoadingButton} width={120} label="Guardar" disabled={!isModified} onClick={saveChanges} />
                                    </div>
                                </Form>
                            </ColSize>
                            <ColSize size={10}>
                                <div className="producer-info-tab__wizard">
                                    <Anchor 
                                        items={ SECTIONS_SIDENAV }
                                        containerId="main-tab-anchor-container"
                                    />
                                </div>
                            </ColSize>
                        </RowSize>
                )
            }
        </div>
    )
}
